import {
	IDailySummary,
	IDashboardResponse,
	IDistrictStat,
	IMonthlyTrend,
	IProblemStat,
	ISourceDistribution,
	PeriodType
} from '../../types/statistics.types'
import { axiosClassic } from '../api'

class StatisticsService {
	private BASE_URL = '/statistics'

	async getDashboard(
		period: PeriodType = '30days',
	): Promise<IDashboardResponse> {
		const { data } = await axiosClassic.get<IDashboardResponse>(this.BASE_URL, {
			params: { period },
		})
		return data
	}

	async getDistrictStats(
		period: PeriodType = '30days',
	): Promise<IDistrictStat[]> {
		const { data } = await axiosClassic.get<IDistrictStat[]>(
			`${this.BASE_URL}/districts`,
			{
				params: { period },
			},
		)
		return data
	}

	async getProblemStats(
		period: PeriodType = '30days',
	): Promise<IProblemStat[]> {
		const { data } = await axiosClassic.get<IProblemStat[]>(
			`${this.BASE_URL}/problems`,
			{
				params: { period },
			},
		)
		return data
	}

	async getMonthlyTrend(): Promise<IMonthlyTrend[]> {
		const { data } = await axiosClassic.get<IMonthlyTrend[]>(
			`${this.BASE_URL}/monthly-trend`,
		)
		return data
	}

	async getSourceDistribution(period: PeriodType = '30days'): Promise<ISourceDistribution> {
		const { data } = await axiosClassic.get<ISourceDistribution>(
			`${this.BASE_URL}/source-distribution`,
			{ params: { period } } 
		)
		return data
	}

	async getDailySummary(): Promise<IDailySummary> {
        const { data } = await axiosClassic.get<IDailySummary>(
            `${this.BASE_URL}/daily-summary`
        )
        return data
    }
}

export const statisticsService = new StatisticsService()
